export default __webpack_public_path__ + "assets/images/for_owners_NnTjQ.jpg";